import axios from "axios";
import { SERVER_URL } from "../socket";

export async function fetchUsers(headers) {
  const res = await axios.get(`${SERVER_URL}/api/admin/users`, { headers });
  return Array.isArray(res.data?.users) ? res.data.users : [];
}

export async function createUser(payload, headers) {
  const res = await axios.post(`${SERVER_URL}/api/admin/users`, payload, { headers });
  return {
    user: res.data?.user || null,
    generatedPassword: res.data?.generatedPassword || null,
  };
}

export async function uploadUsersFile(file, headers) {
  const form = new FormData();
  form.append("file", file);
  const res = await axios.post(`${SERVER_URL}/api/admin/users/upload`, form, {
    headers: {
      ...headers,
      "Content-Type": "multipart/form-data",
    },
  });
  return res.data;
}

export async function toggleUserActive(userId, active, headers) {
  const res = await axios.put(`${SERVER_URL}/api/admin/users/${userId}/active`, { active }, { headers });
  return res.data?.user || null;
}

export async function updateUserStorage(userId, totalStorageGB, headers) {
  const res = await axios.put(`${SERVER_URL}/api/admin/users/${userId}/storage`, { totalStorageGB }, { headers });
  return res.data?.user || null;
}
